import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-flex items-center gap-2 text-xl font-bold font-heading text-white mb-4 no-underline">
              <span className="text-primary-400">91</span>
              <span>免费</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              91免费高清影视在线平台，汇聚最新最全的免费电影资源，为您提供高品质的在线观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 font-heading">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link></li>
              <li><Link to="/category" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">全部分类</Link></li>
              <li><Link to="/category?tab=资讯" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">影视资讯</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 font-heading">热门分类</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/category?type=action" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">动作片</Link></li>
              <li><Link to="/category?type=comedy" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">喜剧片</Link></li>
              <li><Link to="/category?type=scifi" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">科幻片</Link></li>
              <li><Link to="/category?type=anime" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">动漫</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 font-heading">联系我们</h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@91free.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-9091</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>北京市朝阳区影视产业园区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/30">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} 91免费 版权所有 | 本站所有资源均来自互联网，仅供交流学习使用
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}